import React, { useState } from "react";
import ReactDropdown from "react-dropdown";
import { NhanVayCombo } from "constants/nhanVayConst";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatDayMonth } from "utils/formatDate";
import { useSelector, useDispatch } from "react-redux";
import { getListNhanVay, updateDataSearch } from "../../actions/NhanVay/";
import { Testfunction } from "./test2";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";

export const SearchBar = ({ setModalThietLapHienThi, onSearch }) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

 

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: 1,
        })
      );
      dispatch(getListNhanVay(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  var dateFrom = currentDate();
  if (dataSearch.dateFrom === "01/01/2001") dateFrom = "";
  else dateFrom = dataSearch.dateFrom;
  var dateTo = currentDate();
  if (dataSearch.dateTo === "01/01/4000") dateTo = "";
  else dateTo = dataSearch.dateTo;
  dateTo = convertDate(dateTo);
  dateFrom = convertDate(dateFrom);
  return (
    <div
      className="card border-light mb-3 mt-1 hidden-mobile-main show-table-main card-v2"
      style={{ marginTop: "-8px" }}
    >
      <div className="card-body card-body-v2">
        <div className="search-new">
          <div className="input-sm-new input-new-18">
            <label
              htmlFor="customer-name"
              className="font-color-default font-bold"
            >
              Trạng thái
            </label>
            <select
              name="kho"
              className="selectBox form-control input-sm"
              value={dataSearch.status}
              onChange={updateDropdown("status")}
            >
              {NhanVayCombo.StatusCombo &&
                NhanVayCombo.StatusCombo.map((item, idx) => (
                  <option key={"objComboStore1" + idx} value={item.value}>
                    {item.label}
                  </option>
                ))}
            </select>
          </div>

          <div className="input-sm-new input-new-18">
            <label
              htmlFor="customer-name"
              className="font-color-default font-bold"
            >
              Từ ngày
            </label>
            <DateTimePicker
              value={dateFrom}
              onChange={onChangeDate("dateFrom")}
              //onKeyDown={onKeyDownDate}
              placeholder="Từ ngày"
            ></DateTimePicker>
          </div>

          <div className="input-sm-new input-new-18">
            <label
              htmlFor="customer-name"
              className="font-color-default font-bold"
            >
              Đến ngày
            </label>
            <DateTimePicker
              value={dateTo}
              onChange={onChangeDate("dateTo")}
              //onKeyDown={onKeyDownDate("dateFrom")}
              placeholder="Đến ngày"
            ></DateTimePicker>
          </div>
          <div className="input-sm-new input-new-25">
            <label
              htmlFor="customer-name"
              className="font-color-default font-bold"
            >
              Chủ nợ
            </label>
            <input
              type="email"
              className="form-control input-sm"
              placeholder="Tên, sđt chủ nợ"
              value={dataSearch.customerName}
              onChange={updateTextValue("customerName")}
              onKeyDown={handleKeyDown}
            />
          </div>
          <div className="input-sm-new input-new-10 search-main-new">
            <button
              type="submit"
              className="btn btn-info-new btn-seach-ds"
              onClick={onSearch}
            >
              <i className="la la-search"></i>
              <span> &nbsp; Tìm kiếm</span>
            </button>
          </div>
          <div className="input-sm-new input-new-3 search-main-new">
            <label
              htmlFor="customer-name"
              className="font-color-default font-bold"
            >
              &nbsp;
            </label>
            <a
              href={() => false}
              className="card-link blue darken-2 text-search-new filter-search"
              onClick={setModalThietLapHienThi()}
            >
              <i
                className="fa fa-cog icon-bred-home"
                style={{
                  scale: "0.9",
                  verticalAlign: "sub",
                  height: 30,
                }}
              ></i>
            </a>
          </div>
        </div>{" "}

      </div>
    </div>
  );
};
